import { Injectable, group } from '@angular/core';
import { Datipreventivo } from '../model/datipreventivo';
import { Offerte } from '../model/offerte';
import { ConsulenzatelefonicaComponent } from '../consulenzatelefonica/consulenzatelefonica.component';
import { FornitoreServiceService } from './fornitore-service.service';
import { Observable } from 'rxjs/Observable';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class ComparatoretaskService {

  constructor(private servicefornitore: FornitoreServiceService,private http: HttpClient) { }


  public compara(dato: Datipreventivo, items: Array<Offerte>): Observable<Array<Offerte>> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

     


    
    var url =  environment.urlbase + "/api/Comparatore/Compara";

     
    return this.http.post<Array<Offerte>>(url,dato,httpOptions);

  }

  private comparaele(dato: Datipreventivo, items: Array<Offerte>): Array<Offerte> {

    var lst =
      items.filter(o => this.getImportoComparatoEle(dato, o) > 0
      );

    var lstsort = lst.sort((sa, sb) => {
      var importoA = this.getImportoComparatoEle(dato, sa);
      var importoB = this.getImportoComparatoEle(dato, sb);

      return importoA - importoB;
    }

    );

    return lstsort;

  }

  private comparagas(dato: Datipreventivo, items: Array<Offerte>):  Array<Offerte> {

    var lst =
      items.filter(o => this.getImportoComparatoGas(dato, o) > 0
      );

    var lstsort = lst.sort((sa, sb) => {
      var importoA = this.getImportoComparatoGas(dato, sa);
      var importoB = this.getImportoComparatoGas(dato, sb);

      return importoA - importoB;
    }

    );

    // Filtro solo se coperti.
    lstsort = lstsort.filter(item => this.iscopertura(dato, item) == "1")
    return lstsort;

    
  }

  private comparadual(dato: Datipreventivo, items: Array<Offerte>): Array<Offerte> {
    return items.filter(o => o.Id_comodity == 3);
  }
  private compararisaprmio(dato: Datipreventivo, items: Array<Offerte>): Array<Offerte> {
    return items.filter(o => o.Id_comodity == 4);
  }
  private comparaspecial(dato: Datipreventivo, items: Array<Offerte>): Array<Offerte> {
    return items.filter(o => o.Id_comodity == 5);
  }


  public getimporto(dato: Datipreventivo, item: Offerte): number {
    // if (item.Id_comodity == 1)
    //   return this.getImportoComparatoEle(dato, item);
    // if (item.Id_comodity == 2)
    //   return this.getImportoComparatoGas(dato, item);

    // return 5;

    return item.ImportoMensileLordo;
  }
  public getimportoNetto(dato: Datipreventivo, item: Offerte): number {
    // if (item.Id_comodity == 1)
    //   return this.getImportoComparatoEleNetto(dato, item) / 12;
    // if (item.Id_comodity == 2)
    //   return this.getImportoComparatoGasNetto(dato, item) / 12;

    // return 5;

    return item.ImportoMensileNetto;
  }
  public iscopertura(dato: Datipreventivo, item: Offerte): string {
    // if (item.Id_comodity == 1)
    //   return "1"
    // if (item.Id_comodity == 2) {
    // var fornitore = this.servicefornitore.getfornitoribyId(item.Id_Foritore);
  
    //   if (item.Id_Foritore == 3)
    //     return "1";

    //   if (fornitore.lstCapGas.filter(cap => cap == dato.lead.cap).length == 0)
    //     return "0";
    //   return "1";
    // }
    // return "1";
    return item.iscopertura;
  }
  private getImportoComparatoEle(dato: Datipreventivo, item: Offerte): number {
    try {
      var netto = this.getImportoComparatoEleNetto(dato, item);

      return netto * 1.1507 / 12
    }
    catch{ return 0; }
  }
  private getImportoComparatoGas(dato: Datipreventivo, item: Offerte): number {
    try {


      var netto = this.getImportoComparatoGasNetto(dato, item);

      return netto * 1.5948 / 12
    }
    catch{ return 0; }


  }
  private getImportoComparatoEleNetto(dato: Datipreventivo, item: Offerte): number {
    try {
      if (item.Id_comodity != 1)
        return 0;
      if (item.schedaconfrontabilitaele == null)
        return 0;

      var modalitapagamento: string;
      var consumoannuo: number;
      var tipoprofilo: number;
      var residente: number;
      var potenza: number;
      var tipoContratto: number;
      var consumoannuooriginale: number;
      var delta: number;
      var deltaBefore: number;

      var consumoannuoBefore: number;
      var sogliacambio: number;

      consumoannuooriginale = +dato.datiextra.filter(o => o.idDato == 1)[0].valore;
      tipoprofilo = +dato.datiextra.filter(o => o.idDato == 2)[0].valore;
      residente = +dato.datiextra.filter(o => o.idDato == 3)[0].valore;
      potenza = +dato.datiextra.filter(o => o.idDato == 4)[0].valore;
      tipoContratto = +dato.datiextra.filter(o => o.idDato == 5)[0].valore;
      modalitapagamento = dato.datiextra.filter(o => o.idDato == 6)[0].valore;

      var itemsoglia = item.TipoSoglieEle.filter(o => o.Potenza == potenza && o.TipoResidente == residente && consumoannuooriginale >= o.minConsumo && consumoannuooriginale < o.maxConsumo)[0];

      consumoannuo = itemsoglia.consumoAnnuo;
      consumoannuoBefore = itemsoglia.consumoAnnuoBefore;
      sogliacambio = itemsoglia.sogliacambio;

      // switch (true) {
      //   case (consumoannuooriginale < 1950):
      //     consumoannuo = 1200;
      //     consumoannuoBefore=1200;
      //     sogliacambio=0;


      //     break;
      //   case (consumoannuooriginale >= 1950 && consumoannuooriginale < 3000):
      //     consumoannuo = 2700;
      //     consumoannuoBefore=1200;
      //     sogliacambio=1949;


      //     break;
      //   case (consumoannuooriginale >= 3000 && consumoannuooriginale < 4000):
      //     consumoannuo = 3500;
      //     consumoannuoBefore=2700;
      //     sogliacambio=2999;


      //     break;
      //   case (consumoannuooriginale >= 4000):
      //     consumoannuo = 4500;
      //     consumoannuoBefore=3500;
      //     sogliacambio=3999;

      //     break;
      // }

      deltaBefore = consumoannuooriginale / consumoannuoBefore;
      delta = consumoannuooriginale / consumoannuo;




      if (item.lstModalitaPagamento.filter(m => m == modalitapagamento).length == 0)
        return 0;

      if (item.TipoContratto != tipoContratto)
        return 0;

      var importo = item.schedaconfrontabilitaele.tabellaConfrontabilita.filter(sc => sc.potenza == potenza && sc.Residente == residente && sc.tipoprofilo == tipoprofilo && sc.consumoannuo == consumoannuo)[0].importo;
      if (importo == null)
        return 0;

      var importoBefore = item.schedaconfrontabilitaele.tabellaConfrontabilita.filter(sc => sc.potenza == potenza && sc.Residente == residente && sc.tipoprofilo == tipoprofilo && sc.consumoannuo == consumoannuoBefore)[0].importo;


      var netto = +importo * delta;
      var nettoBefore = +(importoBefore + 10) * deltaBefore

      var ConsumoAnnuoRicalcolato = (nettoBefore * consumoannuo / importo);
      var deltaImportoBefore = 1 - (consumoannuooriginale / ConsumoAnnuoRicalcolato);

      // if (netto <75 && netto >0)
      // {
      //   if (residente==1)
      //   {
      //     netto = netto + 75;

      //   }
      //   else
      //   {
      //     netto = netto + 75;
      //   }
      // }

      if (netto < 85 && netto > 0) {
        var consumo85 = 85 * consumoannuo / importo;
        netto = 75 + (consumoannuooriginale / consumo85 * 10);


      }
      netto = netto - (item.scontoRid * (modalitapagamento == "2" ? 1 : 0));
      nettoBefore = nettoBefore - (item.scontoRid * (modalitapagamento == "2" ? 1 : 0));

      if (nettoBefore > netto && delta != deltaBefore) {
        // console.log("calcolo netto before " + item.NomeOfferta);
        // console.log(nettoBefore);
        // console.log(netto);
        // console.log(importo);
        // console.log(importoBefore);
        // console.log(deltaImportoBefore);
        // console.log(ConsumoAnnuoRicalcolato);
        // console.log(((consumoannuooriginale- sogliacmapbio)/ (ConsumoAnnuoRicalcolato-sogliacmapbio)));

        netto = nettoBefore - (10 * (1 - ((consumoannuooriginale - sogliacambio) / (ConsumoAnnuoRicalcolato - sogliacambio))));
        // console.log(netto);
      }

      return netto
    }
    catch{ return 0; }


  }


  private getImportoComparatoGasNetto(dato: Datipreventivo, item: Offerte): number {
    try {
      if (item.Id_comodity != 2)
        return 0;
      if (item.schedaconfrontabilitagas == null)
        return 0;


      var modalitapagamento: string;
      var consumoannuo: number;
      var zona: number;


      var tipoContratto: number;
      var consumoannuooriginale: number;
      var delta: number;

      var deltaBefore: number;

      var consumoannuoBefore: number;
      var sogliacmapbio: number;

      consumoannuooriginale = +dato.datiextra.filter(o => o.idDato == 1)[0].valore;
      // switch (true) {
      //   case (consumoannuooriginale < 125):
      //     consumoannuo = 120;
      //     consumoannuoBefore=120;
      //     deltaBefore= consumoannuooriginale/consumoannuoBefore;
      //     sogliacmapbio=0;
      //     break;
      //   case (consumoannuooriginale >= 125 && consumoannuooriginale < 590):
      //     consumoannuo = 480;
      //     consumoannuoBefore=120;
      //     sogliacmapbio=121;
      //     deltaBefore= sogliacmapbio/consumoannuoBefore;
      //     break;
      //   case (consumoannuooriginale >= 590 && consumoannuooriginale < 1000):
      //     consumoannuo = 700;
      //     consumoannuoBefore=480;
      //     sogliacmapbio=589;
      //     deltaBefore= sogliacmapbio/consumoannuoBefore;
      //     break;
      //   case (consumoannuooriginale >= 1000 && consumoannuooriginale < 1700):
      //     consumoannuo = 1400;
      //     consumoannuoBefore=700;
      //     sogliacmapbio=999;
      //     deltaBefore= sogliacmapbio/consumoannuoBefore;
      //     break;
      //   case (consumoannuooriginale >= 1700 && consumoannuooriginale < 3500):
      //     consumoannuo = 2000;
      //     consumoannuoBefore=1400;
      //     sogliacmapbio=1699;
      //     deltaBefore= sogliacmapbio/consumoannuoBefore;
      //     break;
      //   case (consumoannuooriginale >= 3500):
      //     consumoannuo = 5000;
      //     consumoannuoBefore=2000;
      //     sogliacmapbio=3499;
      //     deltaBefore= sogliacmapbio/consumoannuoBefore;
      //     break;
      // }

      consumoannuo = 480;
      consumoannuoBefore = 480;
      sogliacmapbio = 0;

      deltaBefore = sogliacmapbio / consumoannuoBefore;

      delta = consumoannuooriginale / consumoannuo;


      zona = +dato.datiextra.filter(o => o.idDato == 2)[0].valore;
      tipoContratto = +dato.datiextra.filter(o => o.idDato == 3)[0].valore;

      modalitapagamento = dato.datiextra.filter(o => o.idDato == 4)[0].valore;

      if (item.lstModalitaPagamento.filter(m => m == modalitapagamento).length == 0)
        return 0;
      if (item.TipoContratto != tipoContratto)
        return 0;

      // if ( fornitore.lstCapGas.filter( cap => cap==dato.lead.cap).length==0)
      //   return 0;

      var importo = item.schedaconfrontabilitagas.tabellaConfrontabilita.filter(sc => sc.zona == zona && sc.consumoannuo == consumoannuo)[0].importo;

      if (importo == null)
        return 0;

      var importoBefore = item.schedaconfrontabilitagas.tabellaConfrontabilita.filter(sc => sc.zona == zona && sc.consumoannuo == consumoannuoBefore)[0].importo;


      var netto = +importo * delta;

      var nettoBefore = +(importoBefore + 10) * deltaBefore

      var ConsumoAnnuoRicalcolato = (nettoBefore * consumoannuo / importo);
      var deltaImportoBefore = 1 - (consumoannuooriginale / ConsumoAnnuoRicalcolato);



      // if (netto <75 && netto >0)
      // {    
      //     netto = netto+ 75;
      // }
      if (netto < 85 && netto > 0) {
        var consumo85 = 85 * consumoannuo / importo;
        netto = 75 + (consumoannuooriginale / consumo85 * 10);


      }
      netto = netto - (item.scontoRid * (modalitapagamento == "2" ? 1 : 0));
      nettoBefore = nettoBefore - (item.scontoRid * (modalitapagamento == "2" ? 1 : 0));

      if (nettoBefore > netto && delta != deltaBefore) {
        // console.log("calcolo netto before " + item.NomeOfferta);
        // console.log(nettoBefore);
        // console.log(netto);
        // console.log(importo);
        // console.log(importoBefore);
        // console.log(deltaImportoBefore);
        // console.log(ConsumoAnnuoRicalcolato);
        // console.log(((consumoannuooriginale- sogliacmapbio)/ (ConsumoAnnuoRicalcolato-sogliacmapbio)));

        netto = nettoBefore - (10 * (1 - ((consumoannuooriginale - sogliacmapbio) / (ConsumoAnnuoRicalcolato - sogliacmapbio))));
        // console.log(netto);
      }

      return netto
    }
    catch{ return 0; }


  }
}




// WEBPACK FOOTER //
// ./src/app/service/comparatoretask.service.ts